module.exports = __webpack_public_path__ + "img/W020210831547975276755.1dcee2a0.png";